// extracted by mini-css-extract-plugin
export default {"disabled":"_38xlgyBjqX8Jz3S39sFG1l"};